class ChatbotTeaser {
  /**
   * @param {HTMLElement} element - ChatbotTeaser element
   */
  constructor(element) {
    this.element = element;
    this.button = this.element.querySelector(".js-ChatbotTeaser-button");

    if (this.button) {
      this._bind();
    }
  }

  /**
   * binds event listeners
   *
   * @private
   */
  _bind() {
    this.button?.addEventListener("click", ChatbotTeaser._openWebchat);
  }

  /**
   * opens webchat / chatbot:in with API call
   * webchat is getting initialized in gpde_frontend/templates/core/html/html.html.twig
   * and exposed as global variable window.webchat
   *
   * @static
   * @private
   */
  static _openWebchat() {
    window.webchat?.open();
  }
}

export default ChatbotTeaser;
